import useFormatter from "@coworker/app/src/hooks/useFormatter";
import { useItemExpectedDelivery } from "@coworker/apprestructured/src/shared/hooks/item/useItemExpectedDelivery";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

interface NextDeliveryProps {
  itemNo: string;
}

export const NextDelivery = ({ itemNo }: NextDeliveryProps) => {
  const storeId = useStoreId();
  const { data: itemDeliveryData, isLoading: isLoading } =
    useItemExpectedDelivery(itemNo, storeId);
  const { formatDateShort } = useFormatter();

  return (
    <FixaListViewItem
      size="medium"
      control="default"
      inset
      controlIcon="chevronRight"
      id="next-delivery"
      title={<FixaText textStyle="Heading.XS">Next Delivery</FixaText>}
      description={
        isLoading
          ? "Loading..."
          : itemDeliveryData?.deliveryDate
            ? `(${formatDateShort(itemDeliveryData.deliveryDate)})`
            : ""
      }
    ></FixaListViewItem>
  );
};
